import React from 'react';
import {MENU_IDS} from '../../../constants/menuIds';
import {IElement} from '../../../incase-domain/elements';
import {ContextMenuTrigger} from '../../../incase-domain/components/contextMenu/ContextMenu';

interface ElementContextMenuTriggerProps {
    element: IElement;
    elementIndex: number;
    inHighlightedMode?: boolean;
}

export function ElementContextMenuTrigger({
    element,
    elementIndex,
    inHighlightedMode,
    children,
}: React.PropsWithChildren<ElementContextMenuTriggerProps>): JSX.Element {
    return (
        <ContextMenuTrigger menuId={MENU_IDS.ELEMENT} menuProps={{element, elementIndex, inHighlightedMode}}>
            {children}
        </ContextMenuTrigger>
    );
}

export default React.memo(ElementContextMenuTrigger);
